import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import { Row, Col, Button } from 'reactstrap'
import FalconModal from '../../components/Inputs/FalconModal'
import {
  getResourceSchema,
  getResourceUISchema,
  getMultiResourceSchema,
  getMultiResourceUISchema,
  getDayResourceSchema,
  getDayResourceUISchema,
} from '../../components/Inputs/dataschemas'
import { formatEuro } from '../../components/utils/dayresources'
import { Box, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
// import ReactTable from 'react-table'
import ReactTable from '../../components/Lists/ReactTableWrapper'
// core components
// import moment from 'moment'
// import 'moment/locale/fi'
import { filterCaseInsensitive } from '../../components/FalconTable'
import EditButton from '../../components/Buttons/EditButton'
import DeleteButton from '../../components/Buttons/DeleteButton'

// Access control fields on a resource. They are not in the resource form - customer support
// sets them - so a new resource never gets them on its own.
const ACCESS_CONTROL_FIELDS = ['gates', 'accesslevels', 'contexts']

const hasAccessControlValue = (value) => {
  if (value === undefined || value === null || value === '') return false
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'object') return Object.keys(value).length > 0
  return true
}

const toMultiResources = (snap) =>
  snap.docs
    .map((sh) => ({ ...sh.data(), id: sh.id }))
    .filter((r) => r.state !== 'deleted')
    .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || ''))

class ResourcesContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      resourceModalOpen: false,
      selected: null,
      images: [],
      activeTab: 0,
      multiresources: [],
      multiResourceModalOpen: false,
      selectedMultiResource: null,
      deleteMultiResource: null,
      deletingMultiResource: false,
      dayresources: [],
      dayResourceModalOpen: false,
      selectedDayResource: null,
      deleteDayResource: null,
      deletingDayResource: false,
      accessControlNotice: null,
    }
  }

  createResource = async (resource) => {
    const ref = await this.props.firebase.createResource(resource)
    if (this.othersHaveAccessControl(resource)) {
      this.setState({ accessControlNotice: { name: resource.displayName || resource.name || '' } })
    }
    return ref
  }

  // Whether any other active resource that may be at the new resource's venue has an access
  // control field set. A resource without a venue counts as possibly the same venue: many
  // older ones have none (at Ramu the only resource with access control had none).
  othersHaveAccessControl = (newResource) => {
    return (this.state.resources || []).some((r) => {
      if (r.state === 'deleted') return false
      const venueid = this.withVenueId(r).venueid
      if (newResource.venueid && venueid && venueid !== newResource.venueid) return false
      return ACCESS_CONTROL_FIELDS.some((field) => hasAccessControlValue(r[field]))
    })
  }

  renderAccessControlNotice = () => {
    const notice = this.state.accessControlNotice
    return (
      <Dialog open={!!notice} onClose={() => this.setState({ accessControlNotice: null })}>
        <DialogTitle>Kulunvalvonta uudelle resurssille</DialogTitle>
        <DialogContent>
          <Typography>
            Resurssi {notice && notice.name ? <b>{notice.name}</b> : ''} on lisätty. Muilla resursseilla on käytössä
            kulunvalvonta, jota ei voi asettaa resurssin lomakkeella.
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Jos uudelle resurssille tarvitaan kulunvalvonta, ota yhteyttä asiakastukeen, niin se lisätään.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ accessControlNotice: null })}>Selvä</Button>
        </DialogActions>
      </Dialog>
    )
  }

  componentDidMount() {
    this.initData()
  }


  initData = async () => {
    const [_resources, _resourceCategories, _resourceConfigurations, _venues, _multiresources, _dayresources] = await Promise.all([
      this.props.firebase.getResourses(),
      this.props.firebase.getResourceCategories().get(),
      this.props.firebase.getResourceConfigs(),
      this.props.firebase.getVenues(),
      this.props.firebase.getMultiResources(),
      this.props.firebase.getDayResources(),
    ])
    const resources = _resources.docs.map((sh) => { return { ...sh.data(), id: sh.id } }).sort((a, b) => a.displayName.localeCompare(b.displayName))
    let resourcecategories = {}
    if (_resourceCategories.data()) {
      console.log(_resourceCategories.data())
      resourcecategories = _resourceCategories.data().categories.reduce((acc, curr) => {
        if (!acc[curr.type]) {
          acc[curr.type] = []
        }
        acc[curr.type].push(curr.category)
        return acc
      }, {})
    }
    let resourceconfigurations = []
    if (!_resourceConfigurations.empty) {
      resourceconfigurations = _resourceConfigurations.docs.map((sh) => {
        return { ...sh.data(), id: sh.id }
      })
    }
    let venues = []
    if (!_venues.empty) {
      venues = _venues.docs.map((sh) => {
        return { name: sh.data().name.toLowerCase() , id: sh.id, displayName: sh.data().name }
      })
    }
    const images = await this.props.firebase.getImages()

    this.setState(
      {
        resources,
        resourcecategories,
        resourceconfigurations,
        venues,
        images,
        multiresources: toMultiResources(_multiresources),
        dayresources: toMultiResources(_dayresources),
      },
      this.filterData
    )
  }


  updateData = async () => {
    const _resources = await this.props.firebase.getResourses()
    let _d = _resources.docs.map((sh) => {
      return { ...sh.data(), id: sh.id }
    }).sort((a, b) => a.displayName.localeCompare(b.displayName))
    this.setState(
      {
        resources: _d,
      },
      this.filterData
    )
  }


  filterData = () => {
    let _data = this.state.resources.map((r) => {
      if (r.resourceconfigid) {
        let _rc = this.state.resourceconfigurations.find((rc) => rc.id === r.resourceconfigid)
        if (_rc) {
          r.resourceconfigname = _rc.displayName
        } else {
          r.resourceconfigname = 'default'
        }
      } else {
        r.resourceconfigname = 'default'
      }
      r.venuename = this.venueName(this.withVenueId(r).venueid)
      if (r.multiuse && r.multiuse.length > 0) {
        r.multiusecourt = 'Kyllä'
      } else {
        r.multiusecourt = 'Ei'
      }
      return {
        ...r
      }
    })
    this.setState({ resources: _data, loading: false })
  }

  handleRowSelect = (e) => {
    const resource = this.state.resources.filter((r) => r.id === e)
    // venuename is a table-only display field; keep it out of the saved doc.
    const { venuename, ...selected } = resource[0] || {}
    this.setState({ selectedResource: this.withVenueId(selected) }, this.toggleResourceModal)
  }

  addNewResource = () => {
    this.setState({ selectedResource: {} }, this.toggleResourceModal)
  }

  toggleResourceModal = () => {
    this.setState({
      resourceModalOpen: !this.state.resourceModalOpen,
    })
  }

  getCategoryDeps = () => {
    if (this.state.resourcecategories) {
      const keys = Object.keys(this.state.resourcecategories)
      return keys.map((key) => {
        const names = this.state.resourcecategories[key]
        const dep = {
          properties: {
            type: {
              enum: [key],
            },
            category: {
              type: 'string',
              title: 'Kategoria',
              oneOf: names.map((name) => ({ const: name.toLowerCase(), title: name })),
            },
          },
        }
        return dep
      })
    }
  }

  // Fills the `venueid` dropdown from the venues collection, or hides it if there are none.
  applyVenueOptions = (schema) => {
    const venues = this.state.venues || []
    if (venues.length > 0) {
      schema.properties.venueid.oneOf = venues.map((v) => ({ const: v.id, title: v.displayName }))
    } else {
      delete schema.properties.venueid
    }
  }

  venueName = (venueId) => {
    if (!venueId) return ''
    const v = (this.state.venues || []).find((venue) => venue.id === venueId)
    return v ? v.displayName : venueId
  }

  // Older resources may carry a legacy `venue` (object or id). Preselect it in the form when it
  // matches a venue doc; the legacy field itself is left untouched.
  withVenueId = (resource) => {
    if (!resource || resource.venueid || !resource.venue) return resource
    const legacyId = typeof resource.venue === 'object' ? resource.venue.id : resource.venue
    const match = (this.state.venues || []).find((v) => v.id === legacyId)
    return match ? { ...resource, venueid: match.id } : resource
  }

  createResourceModal = () => {
    const schema = getResourceSchema()
    schema.dependencies.type.oneOf = this.getCategoryDeps()
    this.applyVenueOptions(schema)
    const items = { oneOf: [] }
    this.state.resources.forEach((res) => {
      items.oneOf.push({ const: res.id, title: res.displayName })
    })
    schema.properties.multiuse.items = items

    const rcItems = { oneOf: [] }
    this.state.resourceconfigurations.sort((a, b) => a.displayName.localeCompare(b.displayName)).forEach((res) => {
      rcItems.oneOf.push({ const: res.id, title: res.displayName })
    })
    schema.properties.resourceconfigid.oneOf = rcItems.oneOf

    schema.properties.sponsor.items.images = this.state.images
    schema.properties.image.items.images = this.state.images

    return (
      <FalconModal
        onUpdate={this.props.firebase.updateResource}
        onCreate={this.createResource}
        toggle={this.toggleResourceModal}
        modifiedCallback={this.updateData}
        resource={this.state.selectedResource}
        isOpen={this.state.resourceModalOpen}
        uiSchema={getResourceUISchema()}
        dataSchema={schema}
        title={
          this.state.selectedResource && this.state.selectedResource.id
            ? 'Muokkaa resurssia'
            : 'Uusi resurssi'
        }
      />
    )
  }

  // --- Multiresources (virtual resources linking real ones) ---

  updateMultiResources = async () => {
    const _multiresources = await this.props.firebase.getMultiResources()
    this.setState({ multiresources: toMultiResources(_multiresources) })
  }

  addNewMultiResource = () => {
    this.setState({ selectedMultiResource: {} }, this.toggleMultiResourceModal)
  }

  handleMultiResourceSelect = (id) => {
    const selected = this.state.multiresources.find((r) => r.id === id)
    this.setState({ selectedMultiResource: selected }, this.toggleMultiResourceModal)
  }

  toggleMultiResourceModal = () => {
    this.setState({ multiResourceModalOpen: !this.state.multiResourceModalOpen })
  }

  // Only active real resources can be linked; multiresources never nest.
  linkableResources = () => this.state.resources.filter((r) => r.state !== 'deleted')

  // A multiresource has no real type, so it may take any configured category (all types),
  // using the same lower-cased value as getCategoryDeps.
  multiResourceCategoryOptions = () => {
    const seen = new Set()
    const options = []
    Object.values(this.state.resourcecategories || {}).forEach((names) => {
      names.forEach((name) => {
        const value = name.toLowerCase()
        if (seen.has(value)) return
        seen.add(value)
        options.push({ const: value, title: name })
      })
    })
    return options.sort((a, b) => a.title.localeCompare(b.title))
  }

  linkedResourceNames = (multiresource) => {
    const ids = multiresource.resources || []
    return ids
      .map((id) => {
        const r = this.state.resources.find((res) => res.id === id)
        return r ? r.displayName : '(poistettu resurssi)'
      })
      .join(', ')
  }

  confirmDeleteMultiResource = async () => {
    const target = this.state.deleteMultiResource
    if (!target) return
    this.setState({ deletingMultiResource: true })
    try {
      await this.props.firebase.deleteResource(target.id)
      await this.updateMultiResources()
    } catch (error) {
      console.error(error)
    }
    this.setState({ deletingMultiResource: false, deleteMultiResource: null })
  }

  createMultiResourceModal = () => {
    const schema = getMultiResourceSchema()
    const linkable = this.linkableResources()
    schema.properties.resources.items.oneOf = linkable.length > 0
      ? linkable.map((res) => ({ const: res.id, title: res.displayName }))
      : [{ const: '', title: 'Ei resursseja' }]
    const categoryOptions = this.multiResourceCategoryOptions()
    if (categoryOptions.length > 0) {
      schema.properties.category.oneOf = categoryOptions
    } else {
      delete schema.properties.category
    }
    this.applyVenueOptions(schema)
    return (
      <FalconModal
        onUpdate={this.props.firebase.updateMultiResource}
        onCreate={this.props.firebase.createMultiResource}
        toggle={this.toggleMultiResourceModal}
        modifiedCallback={this.updateMultiResources}
        resource={this.state.selectedMultiResource}
        isOpen={this.state.multiResourceModalOpen}
        uiSchema={getMultiResourceUISchema()}
        dataSchema={schema}
        title={
          this.state.selectedMultiResource && this.state.selectedMultiResource.id
            ? 'Muokkaa moniresurssia'
            : 'Uusi moniresurssi'
        }
      />
    )
  }

  renderDeleteMultiResourceDialog = () => {
    const target = this.state.deleteMultiResource
    return (
      <Dialog open={!!target} onClose={() => this.setState({ deleteMultiResource: null })}>
        <DialogTitle>Poista moniresurssi</DialogTitle>
        <DialogContent>
          <Typography>Poistetaanko moniresurssi {target ? target.displayName : ''}? Linkitetyt resurssit eivät poistu.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteMultiResource: null })}>Peruuta</Button>
          <Button color='danger' disabled={this.state.deletingMultiResource} onClick={this.confirmDeleteMultiResource}>
            Poista
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderMultiResourcesTab = () => {
    return (
      <>
        <Row>
          <Col>
            <Button onClick={this.addNewMultiResource}>Lisää moniresurssi</Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Typography variant='body2' sx={{ color: 'text.secondary', mb: 1 }}>
              Moniresurssi on virtuaalinen resurssi, joka koostuu muista resursseista. Se ei näy kalentereissa eikä resurssilistoissa.
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <ReactTable
              data={this.state.multiresources.map((r) => ({ ...r, linkednames: this.linkedResourceNames(r), venuename: this.venueName(r.venueid) }))}              filterable
              noDataText='Ei löytynyt yhtään moniresurssia'
              defaultFilterMethod={(filter, row) =>
                filterCaseInsensitive(filter, row)
              }
              columns={[
                {
                  Header: 'Nimi',
                  accessor: 'displayName',
                },
                {
                  Header: 'Kategoria',
                  accessor: 'category',
                },
                {
                  Header: 'Laji',
                  accessor: 'sport',
                },
                {
                  Header: 'Paikka',
                  accessor: 'venuename',
                },
                {
                  Header: 'Linkitetyt resurssit',
                  accessor: 'linkednames',
                },
                {
                  Header: 'Järjestys',
                  accessor: 'order',
                },
                {
                  Header: 'Muokkaa',
                  accessor: 'actions',
                  sortable: false,
                  filterable: false,
                  renderCell: (params) => {
                    return (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <EditButton onClick={() => this.handleMultiResourceSelect(params.row.id)} />
                        <DeleteButton disablediv onClick={() => this.setState({ deleteMultiResource: params.row })} />
                      </Box>
                    )
                  }
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className='-striped -highlight primary-pagination'
            />
          </Col>
        </Row>
        {this.createMultiResourceModal()}
        {this.renderDeleteMultiResourceDialog()}
      </>
    )
  }

  // --- Day resources (päiväresurssit, booked per calendar day in Päivävaraukset) ---

  updateDayResources = async () => {
    const _dayresources = await this.props.firebase.getDayResources()
    this.setState({ dayresources: toMultiResources(_dayresources) })
  }

  addNewDayResource = () => {
    this.setState({ selectedDayResource: { quantity: 1, vat: 25.5 } }, this.toggleDayResourceModal)
  }

  handleDayResourceSelect = (id) => {
    const r = this.state.dayresources.find((x) => x.id === id)
    // the form edits euros; stored as cents in pricePerDay
    const { venuename, ...rest } = r || {}
    const price = typeof rest.pricePerDay === 'number' ? rest.pricePerDay / 100 : undefined
    this.setState({ selectedDayResource: { ...rest, price } }, this.toggleDayResourceModal)
  }

  toggleDayResourceModal = () => {
    this.setState({ dayResourceModalOpen: !this.state.dayResourceModalOpen })
  }

  toDayResourceDoc = (formData) => {
    const { price, ...rest } = formData
    return { ...rest, pricePerDay: Math.round((Number(price) || 0) * 100) }
  }

  saveNewDayResource = (formData) => this.props.firebase.createDayResource(this.toDayResourceDoc(formData))

  saveDayResource = (formData) => this.props.firebase.updateDayResource(this.toDayResourceDoc(formData))

  confirmDeleteDayResource = async () => {
    const target = this.state.deleteDayResource
    if (!target) return
    this.setState({ deletingDayResource: true })
    try {
      await this.props.firebase.deleteResource(target.id)
      await this.updateDayResources()
    } catch (error) {
      console.error(error)
    }
    this.setState({ deletingDayResource: false, deleteDayResource: null })
  }

  createDayResourceModal = () => {
    const schema = getDayResourceSchema()
    const categoryOptions = this.multiResourceCategoryOptions()
    if (categoryOptions.length > 0) {
      schema.properties.category.oneOf = categoryOptions
    } else {
      delete schema.properties.category
    }
    this.applyVenueOptions(schema)
    return (
      <FalconModal
        onUpdate={this.saveDayResource}
        onCreate={this.saveNewDayResource}
        toggle={this.toggleDayResourceModal}
        modifiedCallback={this.updateDayResources}
        resource={this.state.selectedDayResource}
        isOpen={this.state.dayResourceModalOpen}
        uiSchema={getDayResourceUISchema()}
        dataSchema={schema}
        title={
          this.state.selectedDayResource && this.state.selectedDayResource.id
            ? 'Muokkaa päiväresurssia'
            : 'Uusi päiväresurssi'
        }
      />
    )
  }

  renderDeleteDayResourceDialog = () => {
    const target = this.state.deleteDayResource
    return (
      <Dialog open={!!target} onClose={() => this.setState({ deleteDayResource: null })}>
        <DialogTitle>Poista päiväresurssi</DialogTitle>
        <DialogContent>
          <Typography>
            Poistetaanko {target ? target.displayName : ''}? Sitä ei voi enää varata. Tehdyt varaukset säilyvät ja
            niiden laskutus toimii edelleen.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteDayResource: null })}>Peruuta</Button>
          <Button color='danger' disabled={this.state.deletingDayResource} onClick={this.confirmDeleteDayResource}>
            Poista
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderDayResourcesTab = () => {
    return (
      <>
        <Row>
          <Col>
            <Button onClick={this.addNewDayResource}>Lisää päiväresurssi</Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Typography variant='body2' sx={{ color: 'text.secondary', mb: 1 }}>
              Päiväresurssi varataan kokonaisiksi päiviksi (esim. mökki tai vuokravälineet). Se ei näy tuntikalentereissa;
              varaukset tehdään Päivävaraukset-sivulla.
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <ReactTable
              data={this.state.dayresources.map((r) => ({
                ...r,
                pricetext: formatEuro(r.pricePerDay),
                venuename: this.venueName(r.venueid),
              }))}
              filterable
              noDataText='Ei päiväresursseja'
              defaultFilterMethod={(filter, row) => filterCaseInsensitive(filter, row)}
              columns={[
                { Header: 'Nimi', accessor: 'displayName' },
                { Header: 'Määrä', accessor: 'quantity' },
                { Header: 'Hinta / päivä', accessor: 'pricetext' },
                { Header: 'ALV %', accessor: 'vat' },
                { Header: 'Tuotekoodi', accessor: 'product' },
                { Header: 'Paikka', accessor: 'venuename' },
                {
                  Header: 'Muokkaa',
                  accessor: 'actions',
                  sortable: false,
                  filterable: false,
                  renderCell: (params) => (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <EditButton onClick={() => this.handleDayResourceSelect(params.row.id)} />
                      <DeleteButton disablediv onClick={() => this.setState({ deleteDayResource: params.row })} />
                    </Box>
                  ),
                },
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className='-striped -highlight primary-pagination'
            />
          </Col>
        </Row>
        {this.createDayResourceModal()}
        {this.renderDeleteDayResourceDialog()}
      </>
    )
  }

  renderResourcesTab = () => {
    if (!this.state.resourcecategories || Object.keys(this.state.resourcecategories).length === 0) {
      return (
        <Row>
          <Col>
            Lisää ensin resurssikategoria
          </Col>
        </Row>
      )
    }
    return (
      <>
        <Row>
          <Col>
            <Button onClick={this.addNewResource}>Lisää resurssi</Button>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <ReactTable
              data={this.state.resources}
              filterable
              noDataText='Ei löytynyt yhtään resurssia'
              defaultFilterMethod={(filter, row) =>
                filterCaseInsensitive(filter, row)
              }
              columns={[
                {
                  Header: 'Nimi',
                  accessor: 'displayName',
                },
                {
                  Header: 'Tyyppi',
                  accessor: 'type',
                },
                {
                  Header: 'Kategoria',
                  accessor: 'category',
                },
                {
                  Header: 'Tuotekoodi',
                  accessor: 'product',
                },
                {
                  Header: 'ALV %',
                  accessor: 'vat',
                },
                {
                  Header: 'Laji',
                  accessor: 'sport',
                },
                {
                  Header: 'Paikka',
                  accessor: 'venuename',
                },
                {
                  Header: 'Kirjanpidon tili',
                  accessor: 'accounting',
                },
                // {
                //   Header: 'Konfiguraatio',
                //   accessor: 'resourceconfigname',
                // },
                {
                  Header: 'Monikäyttöinen',
                  accessor: 'multiusecourt',
                },
                {
                  Header: 'Järjestys',
                  accessor: 'order',
                },
                { 
                  Header: 'Sponsori',
                  accessor: 'sponsor',
                  renderCell: (params) => {
                    if (params.row.sponsor) {
                      const { url } = params.row.sponsor
                      if (!url) return null
                      const _url = url.split('/').splice(0, url.split('/').length - 1).join('/') + '/60_' + url.split('/').splice(-1)
                      return (
                        <img height={20} src={_url} alt='sponsor' />
                      )
                    } else {
                      return null
                    }
                  }
                },
                {
                  Header: 'Muokkaa',
                  accessor: 'actions',
                  sortable: false,
                  filterable: false,
                  renderCell: (params) => {
                    return (
                      <EditButton
                        onClick={() => this.handleRowSelect(params.row.id)}
                      />
                    )
                  }
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      this.handleRowSelect(rowInfo.row._original.id)
                    },
                  }
                } else {
                  return {}
                }
              }}
              className='-striped -highlight primary-pagination'
            />
          </Col>
        </Row>
        <Row>
          <Col md='12'></Col>
        </Row>
        {this.state.alert}
        {this.createResourceModal()}
        {this.renderAccessControlNotice()}
      </>
    )
  }

  render() {
    if (this.state.loading) {
      return (
        <>
          <div className='content'>
            <Row>
              <Col>
                Loading ...
              </Col>
            </Row>
          </div>
        </>
      )
    }
    return (
      <>
        <div className='content'>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={this.state.activeTab} onChange={(e, activeTab) => this.setState({ activeTab })}>
              <Tab label='Resurssit' />
              <Tab label='Moniresurssit' />
              <Tab label='Päiväresurssit' />
            </Tabs>
          </Box>
          {this.state.activeTab === 0 && this.renderResourcesTab()}
          {this.state.activeTab === 1 && this.renderMultiResourcesTab()}
          {this.state.activeTab === 2 && this.renderDayResourcesTab()}
        </div>
      </>
    )
  }
}

export default withFirebase(ResourcesContainer)
